import * as React from "react";
import styles from "~/areas/infrastructure/components/DeploymentTargets/style.module.less";
import type { DropdownMenuOption } from "~/primitiveComponents/form/Select/DropDownMenu";
import { SelectField } from "~/primitiveComponents/form/Select/SelectField";
export enum DeploymentTargetDeploymentsGrouping {
    None = "No Grouping",
    ByProject = "By Project"
}
export interface DeploymentTargetDeploymentsGroupingMenuProps {
    grouping: DeploymentTargetDeploymentsGrouping;
    onChange: (grouping: DeploymentTargetDeploymentsGrouping) => void;
}
export const DeploymentTargetDeploymentsGroupingMenu = ({ grouping, onChange }: DeploymentTargetDeploymentsGroupingMenuProps) => {
    const groupingMenuItems: DropdownMenuOption[] = [
        { value: DeploymentTargetDeploymentsGrouping.None, text: DeploymentTargetDeploymentsGrouping.None, onChange: () => onChange(DeploymentTargetDeploymentsGrouping.None) },
        { value: DeploymentTargetDeploymentsGrouping.ByProject, text: DeploymentTargetDeploymentsGrouping.ByProject, onChange: () => onChange(DeploymentTargetDeploymentsGrouping.ByProject) },
    ];
    return (<div className={styles.groupByMenu}>
            <SelectField className={styles.groupByMenu} placeholder="Group by" value={grouping} items={groupingMenuItems}/>
        </div>);
};
